import { fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth';

export const amplifyUtils = { fetchAuthSession, fetchUserAttributes };
